/** CRA/dotenv may leave wrapping quotes in the value (e.g. 'http://host'). */
export function getInvestorApiBase() {
  let base = (process.env.REACT_APP_ASSET_OWNER_Url || "").trim();
  if (
    (base.startsWith("'") && base.endsWith("'")) ||
    (base.startsWith('"') && base.endsWith('"'))
  ) {
    base = base.slice(1, -1).trim();
  }
  return base.replace(/\/$/, "");
}
